<template>
  <el-dialog
    title="核对下发协议"
    :visible.sync="visibleProxy"
    width="620px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    class="protocol-command-confirm-dialog"
    @closed="resetReview"
  >
    <div class="protocol-command-confirm-dialog__content">
      <p class="protocol-command-confirm-dialog__notice">
        请核对以下{{ commandLabel }}的最终 <code>ms</code> 报文。协议一经下发，设备将立即执行。
      </p>

      <div class="protocol-command-confirm-dialog__protocol" aria-label="待下发的协议内容">
        <span>ms</span>
        <code>{{ protocol }}</code>
      </div>

      <p class="protocol-command-confirm-dialog__hint">
        已按协议固定长度生成：{{ protocol.length }} 个十六进制字符。
      </p>

      <el-checkbox v-model="reviewed" class="protocol-command-confirm-dialog__check">
        我已核对上述协议内容，确认下发至当前设备
      </el-checkbox>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button :disabled="submitting" @click="visibleProxy = false">取消</el-button>
      <el-button
        type="primary"
        :loading="submitting"
        :disabled="!reviewed || submitting"
        @click="confirm"
      >
        确认下发
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
const COMMAND_LABELS = {
  AA02: "主机系统参数",
  AA03: "滤料寿命参数",
  AA04: "设备使用期限参数",
  AA05: "杀菌消毒参数",
  AA06: "主机时钟参数"
};

export default {
  name: "ProtocolCommandConfirmDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    command: {
      type: Object,
      default: () => ({})
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      reviewed: false
    };
  },
  computed: {
    visibleProxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    protocol() {
      return this.command && this.command.ms ? this.command.ms : "";
    },
    commandLabel() {
      return COMMAND_LABELS[this.protocol.slice(0, 4)] || "设备参数";
    }
  },
  watch: {
    value(visible) {
      if (visible) {
        this.reviewed = false;
      }
    },
    protocol() {
      this.reviewed = false;
    }
  },
  methods: {
    resetReview() {
      this.reviewed = false;
    },
    confirm() {
      if (!this.reviewed || this.submitting || !this.protocol) {
        return;
      }

      this.$emit("confirm", this.command);
    }
  }
};
</script>

<style lang="scss" scoped>
.protocol-command-confirm-dialog /deep/ .el-dialog {
  border: 1px solid #2b88f5;
  background: #0e2035;
}

.protocol-command-confirm-dialog /deep/ .el-dialog__header {
  padding: 18px 20px;
  background: linear-gradient(90deg, #3091ff 0%, #023ba3 100%);
}

.protocol-command-confirm-dialog /deep/ .el-dialog__title,
.protocol-command-confirm-dialog /deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.protocol-command-confirm-dialog /deep/ .el-dialog__body {
  padding: 24px 28px 16px;
  background: #0e2035;
}

.protocol-command-confirm-dialog /deep/ .el-dialog__footer {
  padding: 12px 28px 24px;
  background: #0e2035;
}

.protocol-command-confirm-dialog__notice,
.protocol-command-confirm-dialog__hint {
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 14px;
  line-height: 22px;
}

.protocol-command-confirm-dialog__protocol {
  display: flex;
  margin: 16px 0 8px;
  padding: 14px 16px;
  align-items: flex-start;
  border: 1px solid rgba(63, 175, 255, 0.58);
  background: rgba(48, 145, 255, 0.12);
}

.protocol-command-confirm-dialog__protocol span {
  margin-right: 12px;
  color: #3fafff;
  font-weight: 600;
}

.protocol-command-confirm-dialog__protocol code {
  overflow-wrap: anywhere;
  color: #fff;
  font-family: Consolas, "Courier New", monospace;
  font-size: 15px;
  letter-spacing: 0.4px;
  line-height: 22px;
}

.protocol-command-confirm-dialog__hint {
  color: #3fafff;
}

.protocol-command-confirm-dialog__check {
  display: block;
  margin-top: 22px;
}

.protocol-command-confirm-dialog /deep/ .el-checkbox__label {
  color: rgba(255, 255, 255, 0.9);
}

.protocol-command-confirm-dialog /deep/ .el-button {
  min-width: 92px;
}
</style>
